import { FileType } from "../../../../models";
import { DeveloperProjectCardWithTabsTemplate } from "../../../../templates/DeveloperProjectCardWithTabsTemplate";
import { useProject } from "./useProject";

const Project = (): JSX.Element => {
  const { projectDetails, handleBackClick, tabsList, backButtonText } = useProject();
  return (
    <DeveloperProjectCardWithTabsTemplate
      activeElement="Projects"
      pageTitle={projectDetails?.displayName}
      projectCode={projectDetails?.standard.displayName}
      projectVerifier={projectDetails?.validator?.displayName}
      projectDeveloper={projectDetails?.developer.displayName}
      projectDeveloperIcon={projectDetails?.developer.files.find((f) => f.type === FileType.SmallLogo)?.file.url}
      projectStatus={projectDetails?.status}
      projectUuid={projectDetails?.uuid}
      chartData={{
        Available: projectDetails?.cachedAvailableQuantity || 0,
        Reserved: projectDetails?.cachedReservedQuantity || 0,
        Sold: projectDetails?.cachedSoldQuantity || 0,
      }}
      tabsList={tabsList}
      backButtonText={backButtonText}
      handleBackClick={handleBackClick}
    />
  );
};

export default Project;
